var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teacher-activity-trend-container"},[_vm._m(0),_c('div',{staticClass:"container"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},style:({zoom:`${_vm.zoom}`,transformOrigin:'0 0'}),attrs:{"id":"teacher-activity-trend-echarts-id"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span'),_c('span',[_vm._v("教师活跃趋势")])])
}]

export { render, staticRenderFns }